import Accounting from "accounting";
import PropTypes from "prop-types";
import React from "react";
import { Row, Col, Button, FormControl, FormGroup, ControlLabel, HelpBlock } from "react-bootstrap";

import ModalWrapper from "./ModalWrapper";
import _ from "lodash";

export default class CurrencyEditModal extends React.Component {
	constructor(props) {
		super(props);

		let currency = props.currency || {};
		if (typeof currency.format === "undefined")
		{
			// Serialize and deserialize to clone, don't want to edit defaults
			currency.format = JSON.parse(JSON.stringify(Accounting.settings.currency.format));
		}
		if (typeof currency.format === "string")
		{
			// This is temporary code to handle the migration of previous code
			currency.format = { pos: currency.format, neg: currency.format.replace("%v", "-%v"), zero: currency.format };
		}

		this.state = {
			currency,
			errors: null
		};
		this.handleClose = this.handleClose.bind(this);
		this.handleSave = this.handleSave.bind(this);
		this.handleCurrencyNameChange = this.handleCurrencyNameChange.bind(this);
		this.handleCurrencySymbolChange = this.handleCurrencySymbolChange.bind(this);
		this.handleCurrencyFormatChange = this.handleCurrencyFormatChange.bind(this);
		this.handleCurrencyCodeChange = this.handleCurrencyCodeChange.bind(this);
	}

	handleSave() {
		this.setState({ errors: null });
		let currencyClone = JSON.parse(JSON.stringify(this.state.currency));
		currencyClone.format = JSON.stringify(currencyClone.format);
		this.props.onSave(currencyClone).then(() => {
			this.handleClose();
		}).catch(result => {
			let errors = null;
			if (result && result.response && result.response.body) {
				errors = result.response.body;
			}
			this.setState({ errors });
		});
	}

	handleClose() {
		this.props.onClose();
	}

	handleCurrencyNameChange(event) {
		const currency = this.state.currency;
		currency.name = event.target.value;

		this.setState({ currency });
	}

	handleCurrencySymbolChange(event) {
		const currency = this.state.currency;
		currency.symbol = event.target.value;

		this.setState({ currency });
	}

	handleCurrencyFormatChange(type, event) {
		const currency = this.state.currency;
		if (!currency.format)
		{
			currency.format = {};
		}
		if (type === "pos")
		{
			currency.format.pos = event.target.value;
		}
		if (type === "neg")
		{
			currency.format.neg = event.target.value;
		}
		if (type === "zero")
		{
			currency.format.zero = event.target.value;
		}

		this.setState({ currency });
	}

	handleCurrencyCodeChange(event) {
		const currency = this.state.currency;
		currency.currencyDefinitionId = event.target.value;

		this.setState({ currency });
	}

	render() {
		const { currency, errors } = this.state;
		const currencyDefinitions = this.props.currencyDefinitions || [];
		let selectedCurrencyDefinition = null;
		if (currency.currencyDefinitionId)
		{
			selectedCurrencyDefinition = currencyDefinitions.find(c => c.id === currency.currencyDefinitionId);
		}

		let sampleFormatOptions = { symbol: currency.symbol || "$", format: currency.format };
		if (selectedCurrencyDefinition && (selectedCurrencyDefinition.numberDecimals || selectedCurrencyDefinition.numberDecimals === 0))
		{
			sampleFormatOptions.precision = selectedCurrencyDefinition.numberDecimals;
		}
		else
		{
			sampleFormatOptions.precision = 2;
		}

		const footerElements = [
			<Button key={0} onClick={this.handleSave}>Save</Button>,
			<Button key={1} onClick={this.handleClose}>Close</Button>
		];

		return (
			<ModalWrapper
				title={"Currency Edit"}
				modalClassName={"budget-audit-modal"}
				footerElements={footerElements}
			>
				<div>
					<FormGroup>
						<Row>
							<Col xs={6}>
								<ControlLabel>Name:</ControlLabel>
							</Col>
							<Col xs={6}>
								<FormControl
									type="text"
									placeholder="Name"
									className="mousetrap-mod"
									value={currency.name || ""}
									onChange={this.handleCurrencyNameChange}
									autoFocus={true}
								/>
							</Col>
						</Row>
					</FormGroup>
					<FormGroup>
						<Row>
							<Col xs={6}>
								<ControlLabel>Symbol:</ControlLabel>
							</Col>
							<Col xs={6}>
								<FormControl
									type="text"
									placeholder="Symbol"
									className="mousetrap-mod"
									value={currency.symbol || ""}
									onChange={this.handleCurrencySymbolChange}
								/>
							</Col>
						</Row>
					</FormGroup>
					<FormGroup>
						<Row>
							<Col xs={6}>
								<ControlLabel>Format (positive):</ControlLabel>
							</Col>
							<Col xs={6}>
								<FormControl
									type="text"
									placeholder="Format"
									className="mousetrap-mod"
									value={currency.format ? currency.format.pos || "" : ""}
									onChange={this.handleCurrencyFormatChange.bind(this,  "pos")}
								/>
							</Col>
						</Row>
						<Row>
							<Col xs={12}>
								<HelpBlock>Format string (%v = value, %s = symbol): {Accounting.formatMoney(5000, sampleFormatOptions)}</HelpBlock>
							</Col>
						</Row>
					</FormGroup>
					<FormGroup>
						<Row>
							<Col xs={6}>
								<ControlLabel>Format (negative):</ControlLabel>
							</Col>
							<Col xs={6}>
								<FormControl
									type="text"
									placeholder="Format"
									className="mousetrap-mod"
									value={currency.format ? currency.format.neg || "" : ""}
									onChange={this.handleCurrencyFormatChange.bind(this,  "neg")}
								/>
							</Col>
						</Row>
						<Row>
							<Col xs={12}>
								<HelpBlock>Format string (%v = value, %s = symbol): {Accounting.formatMoney(-5000, sampleFormatOptions)}</HelpBlock>
							</Col>
						</Row>
					</FormGroup>
					<FormGroup>
						<Row>
							<Col xs={6}>
								<ControlLabel>Format (zero):</ControlLabel>
							</Col>
							<Col xs={6}>
								<FormControl
									type="text"
									placeholder="Format"
									className="mousetrap-mod"
									value={currency.format ? currency.format.zero || "" : ""}
									onChange={this.handleCurrencyFormatChange.bind(this,  "zero")}
								/>
							</Col>
						</Row>
						<Row>
							<Col xs={12}>
								<HelpBlock>Format string (%v = value, %s = symbol): {Accounting.formatMoney(0, sampleFormatOptions)}</HelpBlock>
							</Col>
						</Row>
					</FormGroup>
					<FormGroup>
						<Row>
							<Col xs={6}>
								<ControlLabel>Currency Code:</ControlLabel>
							</Col>
							<Col xs={6}>
								<FormControl
									componentClass="select"
									placeholder="Currency Code"
									className="mousetrap-mod"
									value={currency.currencyDefinitionId || ""}
									onChange={this.handleCurrencyCodeChange}
									disabled={currency.isInUse}
								>
									<option></option>
									{currencyDefinitions.map(currencyDefinition => {
										return (
											<option key={currencyDefinition.id} value={currencyDefinition.id}>
												{currencyDefinition.name}
											</option>
										);
									})}
								</FormControl>
							</Col>
						</Row>
					</FormGroup>
					{errors && _.keys(errors).map(fieldName => {
						let errorMessages = errors[fieldName];
						return (
							<p key={fieldName} className="text-danger">
								<span>{fieldName}: </span>
								{errorMessages.map((msg, msgIndex) => {
									return (
										<span key={msgIndex}>{msg}</span>
									);
								})}
							</p>
						);
					})}
				</div>
			</ModalWrapper>
		);
	}
}

CurrencyEditModal.propTypes = {
	onClose: PropTypes.func,
	onSave: PropTypes.func,
	currency: PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string,
		symbol: PropTypes.string,
		format: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.shape({ pos: PropTypes.string, neg: PropTypes.string, zero: PropTypes.string })
		]),
		currencyDefinitionId: PropTypes.string,
		isInUse: PropTypes.bool
	}),
	currencyDefinitions: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.string,
		currentRate: PropTypes.number,
		name: PropTypes.string
	}))
};



// WEBPACK FOOTER //
// ./Components/components/CurrencyEditModal.jsx